import Header from "@/components/Header";
import BlogSection from "@/components/BlogSection";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <Hero />
      <BlogSection />
      <Footer />
    </div>
  );
}
